import styles from "./Abc.module.scss";

export default function Abc() {
  return (
    <>
      <div className={styles.header}>Przydatne linki</div>
      <div className={styles.content}>
        <div className={styles.row}>
          <a
            href="https://google.com"
            target="_blank"
            rel="noreferrer"
            className={styles.title}
          >
            Link 1
          </a>
        </div>
        <div className={styles.row}>
          <a
            href="https://google.com"
            target="_blank"
            rel="noreferrer"
            className={styles.title}
          >
            Link 2
          </a>
        </div>
        <div className={styles.row}>
          <a
            href="https://google.com"
            target="_blank"
            rel="noreferrer"
            className={styles.title}
          >
            Link 3
          </a>
        </div>
        <div className={styles.row}>
          <a
            href="https://google.com"
            target="_blank"
            rel="noreferrer"
            className={styles.title}
          >
            Link 4
          </a>
        </div>
        <div className={styles.row}>
          <a
            href="https://google.com"
            target="_blank"
            rel="noreferrer"
            className={styles.title}
          >
            Link 5
          </a>
        </div>
        <div className={styles.row}>
          <a
            href="https://google.com"
            target="_blank"
            rel="noreferrer"
            className={styles.title}
          >
            Link 6
          </a>
        </div>
      </div>
    </>
  );
}
